<template>
  <a>
    <span>Unable to submit some events. Please check for</span><br/>
    <ul>
      <!-- <li>Incomplete information. Please fill in required information and continue submitting</li><br/>
      <li></li> -->
        <li class="modal-body-text" v-for="message in messages">{{message}}</li>
    </ul>
    <span class="modal-body-text">All completed events have been submitted.</span>
  </a>
</template>

<script>
export default {
  name: 'modal-body-show-error-for-submit-all',
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="less">
  .modal-body li {
    list-style-type: disc;
  }
</style>




// WEBPACK FOOTER //
// ModalBodyWithErrorCodes.vue?d4f17f5e